<template>
  <header>
    <ul class="nav">
      <li>
        <router-link
                :to="{ name: 'home' }"
                class="nav-link header-logo"
        >
          <a>
            <span>Keykhosrow</span>
          </a>
        </router-link>
      </li>
    </ul>
    <ul class="nav">
      <li>
        <router-link
                :to="{ name: 'home' }"
                class="nav-link header-index"
        >
          <a>
            <span>home</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
                :to="{ name: 'topic' }"
                class="nav-link"
        >
          <a>
            <span>Topic</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
                :to="{ name: 'support' }"
                class="nav-link"
        >
          <a>
            <span>Support</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
                :to="{ name: 'contact' }"
                class="nav-link"
        >
          <a>
            <span>Contact</span>
          </a>
        </router-link>
      </li>
    </ul>
  </header>
</template>

<script>
  export default {
    name: "Header",

    data() {
      return {
      }
    },
  }
</script>

<style scoped>

</style>